module.exports = __webpack_public_path__ + "static/img/325.9746900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/325.png
// module id = BnLL
// module chunks = 0